import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, validateButtonASIBlock, getStatusFlagValue } from '../../Custom/Custom';
import asiTitle from '../../asi.json';



export default function BlockK({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token

}) {


   const [itemData, setItemData] = useState({});
   const [blockKData, setBlockKData] = useState({});
   const navigate = useNavigate();
   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [buttonStatus, setButtonStatus] = useState('');
   const statusUnitCode = localStorage.getItem('statusUnitCode')
   const roleCodes = decode_token?.id?.ROLE_CODE
      ? String(decode_token.id.ROLE_CODE)
           .split('|')
           .map((r) => String(r).trim())
           .filter(Boolean)
      : [];
   const isDivasiRole = roleCodes.includes('DIVASI');
   const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
   const currentStatusFlag = Array.isArray(blockKData) && blockKData.length > 0 ? blockKData[0]?.statusFlag : '';
   const isDivasiStatusFlagOne = isDivasiRole && String(currentStatusFlag ?? '').trim() === '1';
   const isHqStatusFlagThree = isHqRole && String(currentStatusFlag ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(currentStatusFlag ?? '').trim() === '';
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(12);
  })();
   useEffect(() => {
      blockKAllData();
   }, [])


   // Function to handle page load Form data
   const blockKAllData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      showAppLoading(true)
      try {
         const response = await axios.post(`${API_URL}api/asi/blockKForm`, newObject, config);
         // const response = await axios.post(`https://updesdev.srmtechsol.com/api/asi/blockKForm`, newObject, config);
         const { data, status } = response.data;
         if (status) {
            const responseBlockKData = data.blockKData || [];
            setBlockKData(responseBlockKData)
            const statusFlage = responseBlockKData?.[0]?.statusFlag ?? '';
            const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
            const initialData = {};
            responseBlockKData.forEach(item => {
               initialData[item.ictIndicatorCode] = {
                  dslNo: item.dslNo,
                  surveyYear: item.surveyYear,
                  code: item.code,
                  ictIndicatorCode: item.ictIndicatorCode,
                  ItemsName: item.ItemsName,
                  // ictIndicatorCodeClass:'textBox_back_color_white'
               };
            });

            setItemData(initialData);
            setButtonStatus(IsButtonStatus)
         } else {
            const IsButtonStatus = await validateButtonASIBlock(decode_token, '');
            setButtonStatus(IsButtonStatus);
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

   }

   // Function to handle State on change
   const handleOnChange = (ictIndicatorCode, field, newValue) => {
      setItemData(prevItemData => {
         const updatedItemData = {
            ...prevItemData,
            [ictIndicatorCode]: {
               ...prevItemData[ictIndicatorCode],
               [field]: newValue
            }
         };
         return updatedItemData;
      });
   }


   // Function to handle reset Form Data
   const handleReset = () => {
      const initialData = {};
      blockKData.forEach(item => {
         initialData[item.ictIndicatorCode] = {
            code: '',
            //   ictIndicatorCodeClass:'textBox_back_color_white'
         };
      });

      setItemData(initialData);
   }


   // Function to handle going to the previous block
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      if (confirmed) {
         //  handleSaveData("SAVE");
         navigate("/BlockJ");
      }
   }

   // Function to handle going to the next block
   const handleNext = async () => {
         // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
         if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
            navigate("/BlockL");
            return;
         }
         // DIVASI + statusFlag=1: do not save, just navigate
         if (isDivasiStatusFlagOne) {
            navigate("/BlockL");
            return;
         }
         // HQADM/HQASI + statusFlag=3: do not save, just navigate
         if (isHqStatusFlagThree) {
            navigate("/BlockL");
            return;
         }
         const confirmed = window.confirm("Have you saved your changes?");
         if (!confirmed) return;
         if (statusUnitCode === '5') {

            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               blockValidation()
               navigate("/BlockL")
            }

         } else {
            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               blockValidation()
               navigate("/BlockL");
            }
         }
   }

   //All block validation Data
   const blockValidation = async () => {

      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      }

      try {
         showAppLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {

            if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].length) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
            }

         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
         }
         showAppLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }

   }


   const handleSaveData = async (buttonType) => {

      let customItemCodes = [];
      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

      const allUpdatedItem = itemData;
      for (let ictIndicatorCode in allUpdatedItem) {
         const customObject = {
            dslNo: itemData[ictIndicatorCode].dslNo,
            surveyYear: itemData[ictIndicatorCode].surveyYear,
            code: itemData[ictIndicatorCode].code,
            ictIndicatorCode: itemData[ictIndicatorCode].ictIndicatorCode,
            ItemsName: itemData[ictIndicatorCode].ItemsName,
            statusFlag: clickButtonStatusFlag,
         };
         customItemCodes.push(customObject);
      }
      const newObject = {
         itemCodes: customItemCodes,
         payload: {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear,
            buttonType: buttonType
         }
      }
      showAppLoading(true);
      try {
         const response = await axios.post(`${API_URL}api/asi/blockKFormSaveToDB`, newObject, config);
         const { status, message } = response.data;
         if (status) {
            blockValidation()
            toast.success(message, messages.COLOR_RED);
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

      return false;


   }



   const storedLanguage = localStorage.getItem('language');

   return (
      <div className="card-body">
         {/* <ToastContainer /> */}
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_K_TITLE : asiTitle.en.BLOCK_K_TITLE }} />
         </h4>

         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
               </h6>
               <div className="table-responsive asi_block_table">
                  <table cellpadding="0" cellSpacing="0" id="" className="table table-bordered block_c_table">
                     <thead>
                        <tr>
                        <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.INDICATOR_DURING_FY : asiTitle.en.INDICATOR_DURING_FY} {yearRange}</th>
                           <th><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CODE : asiTitle.en.CODE }} /></th>
                        </tr>
                     </thead>
                     <tbody>
                        {blockKData.length > 0 && blockKData.map((item, i) => {
                           return (
                              <tr key={i}>
                                 <td>
                                    {++i}
                                 </td>
                                 <td>
                                    {item.ItemsName}
                                 </td>
                                 {/* <td className={itemData[item.ictIndicatorCode].ictIndicatorCodeClass}> */}
                                 <td>
                                    <select
                                       className="form-select"
                                       id={`code${i}`}
                                       name={`code${i}`}
                                       value={itemData[item.ictIndicatorCode].code}
                                       onChange={e => handleOnChange(item.ictIndicatorCode, 'code', e.target.value)}
                                    >
                                       <option value="">Select</option>
                                       <option value="1">1</option>
                                       <option value="2">2</option>
                                    </select>
                                 </td>
                              </tr>
                           )
                        })}

                     </tbody>
                  </table>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               <hr />
            </div>

            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="submit"
                  className="btn btn_orange me-1"
                  onClick={() => { window.print() }}
               >Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={(e) => { handleSaveData("SAVE") }}
                  disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
               >
                  Save
               </button>

               <button
                  type="reset"
                  className="btn btn_orange me-1"
                  onClick={handleReset}
               >
                  Reset
               </button>

               <button
                  type="button"
                  className="btn btn_orange"
                  onClick={(e) => (navigate("/dashboard"))}
               >
                  Cancel
               </button>

            </div>

            <div className="col-lg-4 text-center text-lg-end">
               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
               >
                  <i className="fa fa-angle-left me-1"></i>
                  Previous
               </button>

               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
               >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
               </button>

            </div>

         </div>
      </div>
   )
}
